import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import {
    addFriend, startFollow, stopFollow, acceptFriendRequest,
    cancelFriendRequest, deleteFriend, blockFriend, unblockFriend, seeFriendList
} from '../../actions/friendsActions'
import { getUserInfo, getUserPost } from '../../actions/userActions'
import inMemoryJWT from '../../auth/inMemoryJwt';
import MasoryPostLayout from '../../containers/Post/MasoryPost/MasoryPost'
import localStorage from '../../utils/hooks/useLocalStorage';


const MyPost = ({ history, match, isLoading, seeFriendList, friendList, userCount, isLoadingGetUserInfo,
    userPosts, getUserPost }) => {

    const userID = match.params.userID
    const [dataPost, setDataPost] = useState([])
    const { userProfileInfo } = useSelector(state => state.userInfo)

    useEffect(() => {
        if (!(inMemoryJWT.getToken())) {
            inMemoryJWT.getRefreshedToken()
        }
        inMemoryJWT.waitForTokenRefresh().then(() => {


            if (userProfileInfo) {
                let id = userProfileInfo._id
                const isSelf = userProfileInfo._id ===localStorage().getItem('idUser')
                const isProfileChanged = localStorage().getItem('typeProfile') !="user"

              /*   if (userProfileInfo.franchiseID) {
                    if (userProfileInfo.franchiseID.state ===2) {
                        if(!isSelf){
                            id = userProfileInfo.franchiseID._id
                        }

                       
                    }
                } */
                getUserPost(id)
            }


        })
        return () => {

        }
    }, [userProfileInfo])

    return (
        <MasoryPostLayout type="profile" masoryPost={userPosts} linkPath={"/Post/"} />
    )
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo.userProfileInfo,
        userCount: state.userInfo.userProfileCount,
        friendList: state.userInfo.friendList,
        userPosts: state.userInfo.userPosts,
    }
}

export default connect(mapStateToProps, {
    seeFriendList, getUserInfo, getUserPost, addFriend, startFollow, stopFollow, acceptFriendRequest, cancelFriendRequest,
    deleteFriend, blockFriend, unblockFriend
})(MyPost)

